<template>
  <div class="profile container mt-5">
    <div class="row justify-content-center">
      <div class="col-md-8">
        <div class="card">
          <div class="card-header">
            <h1 class="mb-0">👤 Profil Utilisateur</h1>
          </div>
          <div class="card-body">
            <div class="mb-4">
              <h3>Bienvenue, {{ userName }} !</h3>
              <p class="text-muted">Gérez vos préférences utilisateur</p>
            </div>

            <!-- Section Informations -->
            <div class="info-section">
              <h4 class="mb-3">ℹ️ Informations</h4>
              <div class="row">
                <div class="col-md-6">
                  <p><strong>Nom d'utilisateur :</strong> {{ userName }}</p>
                  <p><strong>Navigateur :</strong> {{ browserInfo }}</p>
                </div>
                <div class="col-md-6">
                  <p><strong>Type d'appareil :</strong> {{ deviceType }}</p>
                  <p><strong>Dernière connexion :</strong> {{ lastLogin }}</p>
                </div>
              </div>
            </div>

            <!-- Section Notifications -->
            <div class="notification-info mt-4">
              <div class="alert alert-info" role="alert">
                <i class="fas fa-bell"></i>
                <strong>Notifications :</strong> Vous pouvez gérer vos notifications d'erreur backup directement depuis le menu profil (👤) dans le header.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import NotificationService from '@/services/notificationService'; // Supprimé - remplacé par FCM

export default {
  name: "ProfilePage",
  data() {
    const storedUser = localStorage.getItem("user");
    let name = "Utilisateur";

    if (storedUser) {
      try {
        const userObj = JSON.parse(storedUser);
        name = userObj.name || name;
      } catch (e) {
        console.error("Impossible de parser l'utilisateur depuis le localStorage :", e);
      }
    }

    return {
      userName: name,
      browserInfo: navigator.userAgent.split(' ')[0],
      deviceType: 'desktop',
      lastLogin: 'Aujourd\'hui'
    };
  },
  mounted() {
    this.initializeProfile();
  },
  methods: {
    /**
     * Initialise les informations du profil
     */
    initializeProfile() {
      // Déterminer le type d'appareil
      // this.deviceType = NotificationService.getDeviceType(); // Supprimé - remplacé par FCM
      this.deviceType = 'desktop'; // Valeur par défaut
      
      // Récupérer la dernière connexion depuis localStorage si disponible
      const lastLogin = localStorage.getItem('lastLogin');
      if (lastLogin) {
        this.lastLogin = new Date(lastLogin).toLocaleDateString('fr-FR');
      }
    }
  }
};
</script>

<style scoped>
.profile {
  min-height: 100vh;
}

.card {
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border: none;
}

.card-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
}

.info-section {
  background: #f8f9fa;
  padding: 1.5rem;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

.notification-info {
  margin-top: 1.5rem;
}

.alert-info {
  background-color: #d1ecf1;
  border-color: #bee5eb;
  color: #0c5460;
}

/* Responsive */
@media (max-width: 768px) {
  .profile {
    padding: 1rem;
  }
  
  .card-body {
    padding: 1rem;
  }
  
  .info-section {
    padding: 1rem;
  }
}
</style>
